import * as React from "react";

function YoutubeIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14.5 14.5"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="#5c7980"
        fillRule="evenodd"
        d="M0 1.5A1.5 1.5 0 0 1 1.5 0h11A1.5 1.5 0 0 1 14 1.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 0 12.5zm4.954 3.146v4.848a.46.46 0 0 0 .696.392L9.8 7.463a.46.46 0 0 0 0-.797L5.65 4.254a.46.46 0 0 0-.696.392"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default YoutubeIcon;